import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Mail } from "lucide-react";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");

    const handle = async (e) => {
        e.preventDefault(); setErr(""); setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (e2) { setErr(formatApiError(e2.response?.data?.detail) || e2.message); }
        finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6 paper-bg">
            <div className="w-full max-w-md">
                <div className="flex flex-col items-center text-center mb-8">
                    <img src="/gg-logo.png" alt="German Gymnasium" className="w-20 h-20 object-contain mb-3" />
                    <h1 className="font-heading text-2xl font-black text-oxford">German Gymnasium</h1>
                </div>
                <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
                    <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-oxford mb-4" data-testid="forgot-back">
                        <ArrowLeft className="w-4 h-4" /> Mbrapa në hyrje
                    </Link>
                    <h2 className="font-heading text-2xl font-bold text-slate-900 mb-2">Reset Fjalëkalimi</h2>
                    {sent ? (
                        <div className="space-y-4 text-sm" data-testid="forgot-success">
                            <div className="bg-sage/10 border border-sage/30 text-sage rounded-lg p-4 flex gap-3">
                                <Mail className="w-5 h-5 shrink-0" />
                                <div>Nëse ky email është i regjistruar, do të merrni një link për resetim brenda pak minutave. Kontrolloni edhe folderin e <em>Spam</em>.</div>
                            </div>
                            <Link to="/login" className="block text-center text-oxford font-semibold underline" data-testid="forgot-back-login">Kthehu te hyrja</Link>
                        </div>
                    ) : (
                        <form onSubmit={handle} className="space-y-4" data-testid="forgot-form">
                            <p className="text-sm text-slate-600">Vendos email-in tënd dhe ne do t'ju dërgojmë linkun për resetim.</p>
                            <div>
                                <label className="text-xs font-bold uppercase tracking-widest text-slate-500 block mb-2">Emaili juaj</label>
                                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="emaili.juaj@gmail.com" data-testid="forgot-email-input" className="h-11 bg-white" />
                            </div>
                            {err && <div className="text-sm text-terracotta bg-terracotta/10 border border-terracotta/30 rounded-lg px-4 py-2">{err}</div>}
                            <Button type="submit" disabled={loading} className="w-full h-11 bg-oxford hover:bg-oxfordhover text-white font-semibold" data-testid="forgot-submit">
                                {loading ? "Duke dërguar…" : "Dërgo linkun"}
                            </Button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
